import React, { useMemo } from 'react';
import makeStyles from '@mui/styles/makeStyles';

import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText
} from '@mui/material';

import { useMessages } from 'modules/intl';
import { MySettingsTab } from './utils';

const useStyles = makeStyles((theme) => ({
  drawer: {
    '& .MuiDrawer-paper': {
      position: 'relative'
    },
    width: theme.spacing(drawerWidth),

    minHeight: theme.spacing(61)
  },
  button: {
    '&.Mui-selected': {
      background: '#F5F5F5',
      color: theme.palette.repliconBlue.main
    }
  }
}));
const drawerWidth = 22;

const options = [
  `settings.${MySettingsTab.AUTOPOPULATE}`,
  `settings.${MySettingsTab.STARTENDTIME}`,
  `settings.${MySettingsTab.SMARTSUGGESTION}`
];
type AutoPilotDrawerProp = {
  setSelected: React.Dispatch<React.SetStateAction<MySettingsTab>>;
  selected: MySettingsTab;
};

const AutoPilotDrawer = ({
  selected,
  setSelected
}: AutoPilotDrawerProp): JSX.Element => {
  const classes = useStyles();
  const drawerMessages = useMessages(options);
  const handleListItemClick = (event: any) => {
    setSelected(event.currentTarget.id);
  };
  const drawerOptions = useMemo(
    () => [
      {
        id: MySettingsTab.AUTOPOPULATE,
        label: drawerMessages[`settings.${MySettingsTab.AUTOPOPULATE}`]
      },
      {
        id: MySettingsTab.STARTENDTIME,
        label: drawerMessages[`settings.${MySettingsTab.STARTENDTIME}`]
      },
      {
        id: MySettingsTab.SMARTSUGGESTION,
        label: drawerMessages[`settings.${MySettingsTab.SMARTSUGGESTION}`]
      }
    ],
    [drawerMessages]
  );

  return (
    <>
      <Drawer
        variant="permanent"
        anchor="left"
        className={classes.drawer}
        data-testid="auto-pilot-drawer"
      >
        <List data-testid="auto-pilot-drawer-list">
          {drawerOptions.map((i) => (
            <ListItem key={i.id} disablePadding>
              <ListItemButton
                data-testid={i.id}
                id={i.id}
                onClick={handleListItemClick}
                selected={selected === i.id}
                className={classes.button}
              >
                <ListItemText primary={i.label} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Drawer>
    </>
  );
};

export default React.memo(AutoPilotDrawer);
